/**
 * Domain Configuration
 * Thay đổi domain tại đây sẽ áp dụng cho toàn bộ hệ thống
 */

export const DOMAIN_CONFIG = {
  // Brand Configuration
  BRAND: {
    NAME: "Xoilac TV",
    SHORT_NAME: "Xoilac TV",
    TITLE: "Xoilac TV - Xem Trực Tiếp Bóng Đá Xôi Lạc TV",
    DESCRIPTION: "Xoilac TV trực tiếp bóng đá hôm nay chất lượng Full HD, không giật lag. Cập nhật link xem Xoilac TV mới nhất 2025 nhanh nhất hiện nay!",
    COPYRIGHT: "Xoilac TV"
  },

  // Main domain - Chỉ cần thay đổi tại đây
  MAIN_DOMAIN: "https://deportivo-france.com",
  
  // Alternative domains (nếu có)
  ALTERNATIVE_DOMAINS: [
    "https://deportivo-france.com",
    "https://deportivo-france.com"
  ],
  
  // CDN domain (nếu có)
  CDN_DOMAIN: "https://deportivo-france.com",
  
  // API domain (nếu có)
  API_DOMAIN: "https://deportivo-france.com",
  
  // Static assets domain
  STATIC_DOMAIN: "https://deportivo-france.com",
  
  // Social media handles
  SOCIAL_HANDLES: {
    FACEBOOK: "https://www.facebook.com/cakhiatvorguk/",
    TWITTER: "https://x.com/cakhiatvorguk",
    PINTEREST: "https://www.pinterest.com/cakhiatvorguk/",
    LINKEDIN: "https://www.linkedin.com/in/cakhiatvorguk/",
    YOUTUBE: "https://www.youtube.com/@cakhiatvorguk",
    TWITCH: "https://www.twitch.tv/cakhiatvorguk",
    SOUNDCLOUD: "https://soundcloud.com/cakhiatvorguk",
    VIMEO: "https://vimeo.com/cakhiatvorguk",
    QUORA: "https://www.quora.com/profile/CAKHIA-TV-TV-3",
    TELEGRAM: "https://t.me/cakhiatv"
  },
  
  // Contact information
  CONTACT: {
    EMAIL: "contact@cakhiatv.org.uk",
    PHONE: "+84363666678 ",
    ADDRESS: "64 P. Hoàng Cầu, Chợ Dừa, Đống Đa, Hà Nội, Việt Nam"
  }
};

// Export individual values for convenience
export const {
  BRAND,
  MAIN_DOMAIN,
  ALTERNATIVE_DOMAINS,
  CDN_DOMAIN,
  API_DOMAIN,
  STATIC_DOMAIN,
  SOCIAL_HANDLES,
  CONTACT
} = DOMAIN_CONFIG;

// Default export
export default DOMAIN_CONFIG; 